import { Typography } from "@mui/material";

import SquareChip from "@/components/elements/Chips/SquareChip";
import ListCard from "@/components/Luna/features/ListCard/ListCard";
import useLesson from "@/contexts/useLesson";
import { Problem } from "@/types";
import { htmlContentStyles } from "@/utils/htmlContentStyle";
import { renderMathInHtml } from "@/utils/mathRenderer";
import getQuestionTypeLabel from "@/utils/problems/getQuestionTypeLabel";

interface Props {
  problem: Problem;
  index: number;
  onOpenModal: (index: number) => void;
  isFocused: boolean;
}

const ProblemItem = ({ problem, index, onOpenModal, isFocused }: Props) => {
  const { lessonResourceState } = useLesson();

  const isRead = lessonResourceState?.readItems?.includes(problem.id);

  return (
    <ListCard
      index={index}
      isApproved={problem.isApproved}
      onOpenModal={() => onOpenModal(index)}
      title={`Problem ${index + 1}`}
      status={problem.studentAnswer ? "complete" : "incomplete"}
      id={problem.id}
      isRead={isRead}
      isFocused={isFocused}
      appearance="example"
      viewMoreLabel="View problem"
    >
      <SquareChip
        label={getQuestionTypeLabel(problem.type)}
        sx={{
          mb: 1,
          py: 0,
          px: 0.5,
          borderRadius: 1,
          border: "none",
          backgroundColor: "background.paper",
          color: "text.primary",
          fontWeight: 500,
          textTransform: "none",
          letterSpacing: 0,
        }}
      />
      <Typography
        component="div"
        variant="text13L"
        dangerouslySetInnerHTML={{
          __html: renderMathInHtml(problem.question, problem.formatVersion),
        }}
        sx={{
          ...htmlContentStyles,
          fontSize: "13px",
          cursor: "pointer",
        }}
        onClick={(e) => {
          e.stopPropagation();
          onOpenModal(index);
        }}
      />
    </ListCard>
  );
};

export default ProblemItem;
